(function () {
  'use strict';

  class PerfisCtrl {
    constructor(Authenticator, ServiceVfiltro, FactoryVfiltro) {
      this.auth = Authenticator;
      this.init();

      ServiceVfiltro.init(FactoryVfiltro.get([]));
    }

    init() {
      this.auth.getUser().then((user) => {
        /* eslint-disable */
        const elementContainer = document.querySelector('#perfis-element'),
            perfisElement = document.createElement('pwc-perfis');
        /* eslint-enable */

        if (perfisElement) {
          perfisElement.userData = {
            solucaoIds: user.plain().solucoes.map(solucao => solucao.solucaoId),
            usuario: user.plain()
          };
        }
        elementContainer.appendChild(perfisElement);
      });
    }
  }

  angular.module('perfis').controller('PerfisCtrl', PerfisCtrl);
}());
